import React, { Component } from "react";
import classnames from "classnames";
import styled from "styled-components";

import { IDeviceTeleopConfiguration } from "@formant/core/model/IDeviceTeleopConfiguration";
import { IRtcStream } from "@formant/core/model/IRtcStream";
import { rosTypeTwist } from "@formant/core/model/rosTypes";
import { rtcTwistStreamType } from "@formant/core/model/rtcStreamTypes";
import { Fader } from "@formant/ui/component/common/Fader";
import { Measure } from "@formant/ui/component/common/Measure";

import { operateStore } from "../../stores";
import { ITeleopSession } from "../../teleop/ITeleopSession";
import { getBitsetsFromStreamConfig } from "../../utils/getBitsetsFromStreamConfig";
import { teleopStreamToRtc } from "../../utils/teleopStreamToRtc";
import * as styles from "./Teleop2Controls.scss";
import { Teleop2Commands } from "./TeleopModule/Teleop2Commands/";
import { TeleopJoysticks } from "./TeleopModule/TeleopJoysticks";

const bottomMargin = 60;

export type ControlMode = "button-controls" | "joystick-controls" | "controls";

export interface ITeleopControlsProps {
    session: ITeleopSession;
    configuration: IDeviceTeleopConfiguration;
    sticky?: boolean;
    controlMode?: ControlMode;
}

export class Teleop2Controls extends Component<ITeleopControlsProps> {
    showJoysticks: boolean = false;
    showButtons: boolean = false;

    public render() {
        const { session, configuration, sticky, controlMode } = this.props;
        const { customStreams, rosStreams, joysticks } = configuration;
        const { deviceId } = session;
        const { share } = operateStore;

        if (controlMode) {
            if (controlMode === "button-controls") {
                this.showButtons = true;
                this.showJoysticks = false;
            } else if (controlMode === "joystick-controls") {
                this.showButtons = false;
                this.showJoysticks = true;
            } // } else if (controlMode === "controls") {
            //     this.showButtons = true;
            //     this.showJoysticks = true;
            // }
        }

        const { showButtons, showJoysticks } = this;

        const configuredVelocityStream = joysticks?.length
            ? joysticks[0].velocityStreamName
            : undefined;

        const customVelocityStream = (customStreams || []).find(
            _ =>
                _.rtcStreamType === rtcTwistStreamType &&
                _.mode === "command" &&
                (configuredVelocityStream
                    ? _.valueStreamName === configuredVelocityStream
                    : true),
        );
        const rosVelocityStream = (rosStreams || []).find(
            _ =>
                _.topicType === rosTypeTwist &&
                _.mode === "command" &&
                (configuredVelocityStream
                    ? _.topicName === configuredVelocityStream
                    : true),
        );

        const velocityStream: IRtcStream | undefined = customVelocityStream
            ? {
                  streamName: customVelocityStream.name,
                  streamType: rtcTwistStreamType,
                  entityId: deviceId,
              }
            : rosVelocityStream
              ? teleopStreamToRtc(deviceId, rosVelocityStream)
              : undefined;

        const buttonStreams: IRtcStream[] = getBitsetsFromStreamConfig(
            deviceId,
            configuration,
            "command",
        );

        // const hasControls = !!velocityStream || buttonStreams.length > 0;
        // const visible = armed && hasControls;

        return (
            <Fader
                className={classnames(
                    styles["teleop-controls"],
                    share && styles.share,
                    sticky && styles.sticky,
                )}
                visible={
                    buttonStreams.length > 0 ||
                    (velocityStream !== undefined && joysticks !== undefined)
                }
            >
                <Measure onMeasureResize={this.onResize}>
                    {buttonStreams.length > 0 && showButtons && (
                        <Teleop2Commands
                            session={session}
                            configuration={configuration}
                            streams={buttonStreams}
                            className={styles.commands}
                        />
                    )}

                    {velocityStream && joysticks && showJoysticks && (
                        <TeleopControlsPadding>
                            <TeleopJoysticks
                                velocityStream={velocityStream}
                                session={session}
                                className={styles.joysticks}
                                configuration={joysticks}
                            />
                        </TeleopControlsPadding>
                    )}
                </Measure>
            </Fader>
        );
    }
    private onResize = (width: number, height: number) => {
        operateStore.controlsDimensions = {
            x: width,
            y: height + bottomMargin,
        };
    };
}

const TeleopControlsPadding = styled.div.withConfig({
    displayName: "TeleopControlsPadding-sc",
})`
    padding: 10px;
`;
